import axios from 'axios'

const API_URL = process.env.VUE_APP_AI_AGENT_API_BASE_URL || 'https://localhost:5001/api/'

class FormService {
  // Get all forms for a project
  getFormsByProject (projectId) {
    return axios.get(API_URL + 'projects/' + projectId + '/forms')
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching forms:', error)
        throw error
      })
  }

  // Get specific form - FIXED: now accepts projectId and formId
  getFormById (projectId, formId) {
    return axios.get(API_URL + 'projects/' + projectId + '/forms/' + formId)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching form:', error)
        throw error
      })
  }

  // Create new form
  createForm (projectId, formData) {
    return axios.post(API_URL + 'projects/' + projectId + '/forms', formData)
      .then(response => response.data)
      .catch(error => {
        console.error('Error creating form:', error)
        throw error
      })
  }

  // Update form
  updateForm (projectId, formId, formData) {
    return axios.put(API_URL + 'projects/' + projectId + '/forms/' + formId, formData)
      .then(response => response.data)
      .catch(error => {
        console.error('Error updating form:', error)
        throw error
      })
  }

  // Delete form
  deleteForm (projectId, formId) {
    return axios.delete(API_URL + 'projects/' + projectId + '/forms/' + formId)
      .then(response => response.data)
      .catch(error => {
        console.error('Error deleting form:', error)
        throw error
      })
  }

  // Submit form (public endpoint)
  submitForm (formId, submissionData) {
    return axios.post(API_URL + 'forms/' + formId + '/submit', submissionData)
      .then(response => response.data)
      .catch(error => {
        console.error('Error submitting form:', error)
        throw error
      })
  }

  // Get form submissions
  getFormSubmissions (projectId, formId) {
    return axios.get(API_URL + 'projects/' + projectId + '/forms/' + formId + '/submissions')
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching form submissions:', error)
        throw error
      })
  }

  // Get specific submission
  getSubmissionById (projectId, formId, submissionId) {
    return axios.get(API_URL + 'projects/' + projectId + '/forms/' + formId + '/submissions/' + submissionId)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching submission:', error)
        throw error
      })
  }

  deleteSubmission (projectId, formId, submissionId) {
    return axios.delete(API_URL + 'projects/' + projectId + '/forms/' + formId + '/submissions/' + submissionId)
      .then(response => response.data)
      .catch(error => {
        console.error('Error deleting submission:', error)
        throw error
      })
  }
}

export default new FormService()
